class ScrollingText extends HTMLElement {
  connectedCallback() {
    setTimeout(() => {
      this.initializeWords();
      this.refreshElement();
    }, 300);

    this.isAnimating = false;
    this.previousScrollY = window.scrollY;

    this.scheduleUpdate = this.scheduleUpdate.bind(this);
    this.refreshElement = this.refreshElement.bind(this);
    this.handleScroll = this.handleScroll.bind(this);

    window.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  initializeWords() {
    const originalText = this.querySelector('[data-text-scroll-original]');
    if (!originalText) return;

    const words = originalText.innerHTML.split(' ');
    this.querySelector('[data-text-scroll-overlay]').innerHTML = words
      .map((word) => `<span class="text-scroll__word" data-text-scroll-word>${word}</span> `)
      .join('');
  }

  handleScroll() {
    this.previousScrollY = window.scrollY;
    this.scheduleUpdate();
  }

  scheduleUpdate() {
    if (!this.isAnimating) requestAnimationFrame(this.refreshElement);
    this.isAnimating = true;
  }

  refreshElement() {
    this.isAnimating = false;
    this.animateText();
  }

  animateText() {
    const elementTop = this.calculateOffsetTop(this);
    const viewportHeight = window.innerHeight;
    const startPoint = elementTop - viewportHeight * 0.66;
    const endPoint = startPoint + this.offsetHeight + viewportHeight * 0.33;

    const wordElements = this.querySelectorAll('[data-text-scroll-word]');
    if (!wordElements.length) return;

    if (this.previousScrollY <= startPoint) {
      wordElements.forEach((word) => word.style.setProperty('--percentage', '0%'));
      return;
    }

    if (this.previousScrollY > endPoint) {
      wordElements.forEach((word) => word.style.setProperty('--percentage', '100%'));
      return;
    }

    const totalScrollDistance = endPoint - startPoint;
    const progressRatio = (this.previousScrollY - startPoint) / totalScrollDistance;

    wordElements.forEach((word, i) => {
      const minProgress = i / wordElements.length;
      const maxProgress = (i + 1) / wordElements.length;
      const isActive = progressRatio >= minProgress && progressRatio < maxProgress;

      if (isActive) {
        const wordProgress = (progressRatio - minProgress) / (maxProgress - minProgress);
        word.style.setProperty('--percentage', `${(wordProgress * 100).toFixed(1)}%`);
      } else {
        word.style.setProperty('--percentage', progressRatio > maxProgress ? '100%' : '0%');
      }
    });
  }

  calculateOffsetTop(el, parent = document.body, offset = 0) {
    if (!isNaN(el.offsetTop)) offset += el.offsetTop;
    return el.offsetParent === parent ? offset : this.calculateOffsetTop(el.offsetParent, parent, offset);
  }
}

if (!customElements.get('text-scroll')) {
  customElements.define('text-scroll', ScrollingText);
}
